export const importEnkatregistretApiV1 = (options)=>{
    const demo = !!options?.demo;
    const apiUrl = `/Public/Files/${demo ? 'enkatregistret-demo' : 'enkatregistret'}/js/enkatregistret-api-v1.js`;
    // Bail out of webpack's code-splitting feature.
    return import(/* webpackIgnore: true */ apiUrl);
};
